import { Menu } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  border-radius: unset !important;
  min-width: 250px !important;
  border-right: 1px solid ${({ theme }) => theme['border--muted']} !important;
  box-shadow: unset !important;
`;
